// @unocss-include
'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import classNames, { clsx } from 'clsx';
import { withClassName } from '../../hooks/withClassName.js';
import { BoxContext } from '../box/Box.js';
const StyledContent = withClassName(function DropdownMenuContent(props) {
    return (_jsx(BoxContext.Provider, { value: { spacingScale: 1 }, children: _jsx(DropdownMenuPrimitive.Content, Object.assign({}, props)) }));
}, 'layer-components:min-w-220px layer-components:bg-white layer-components:z-menu layer-components:shadow-lg layer-components:rounded-md layer-components:border layer-components:border-gray-dark', 'layer-components:transform-origin-[var(--radix-dropdown-menu-transform-origin)]', 'layer-components:[&[data-state=open]]:animate-popover-in', 'layer-components:[&[data-state=closed]]:animate-popover-out', 'layer-components:max-h-[var(--radix-dropdown-menu-content-available-height)]', 'important:motion-reduce:animate-none', 'will-change-transform');
const itemClassName = classNames('layer-components:text-md layer-components:leading-4 layer-components:color-black layer-components:flex layer-components:items-center layer-components:pr-4 layer-components:pl-8 layer-components:py-2 layer-components:relative layer-components:text-left layer-components:select-none layer-components:cursor-pointer', 'layer-components:[&[data-disabled]]:color-gray-dark layer-components:[&[data-disabled]]:pointer-events-none', 'layer-components:focus-visible:bg-gray layer-components:focus-visible:bg-lighten-3 layer-components:focus-visible:color-black', 'layer-components:hover:bg-gray layer-components:hover:bg-lighten-3 layer-components:hover:color-black', 'layer-components:focus:outline-none');
const StyledItemBase = withClassName(DropdownMenuPrimitive.Item, itemClassName);
const StyledItem = (_a) => {
    var { ref: forwardedRef, className, color } = _a, props = __rest(_a, ["ref", "className", "color"]);
    return (_jsx(StyledItemBase, Object.assign({}, props, { className: clsx(color === 'destructive' &&
            'layer-variants:color-attention-dark layer-variants:hover:bg-attention-light layer-variants:focus-visible:bg-attention-light', className), ref: forwardedRef })));
};
const StyledCheckboxItem = withClassName(DropdownMenuPrimitive.CheckboxItem, itemClassName);
const StyledRadioItem = withClassName(DropdownMenuPrimitive.RadioItem, itemClassName);
const StyledLabel = withClassName(DropdownMenuPrimitive.Label, 'layer-components:pl-3 layer-components:py-1 layer-components:font-bold layer-components:text-sm layer-components:leading-6');
const StyledSeparator = withClassName(DropdownMenuPrimitive.Separator, 'layer-components:h-1px layer-components:bg-gray layer-components:m-5px');
const StyledItemIndicator = withClassName(DropdownMenuPrimitive.ItemIndicator, 'layer-components:absolute layer-components:left-0 layer-components:w-25px layer-components:inline-flex layer-components:items-center layer-components:justify-center');
const StyledArrow = withClassName(DropdownMenuPrimitive.Arrow, 'layer-components:arrow');
const StyledTrigger = withClassName(DropdownMenuPrimitive.Trigger, 'select-none');
const StyledPortal = DropdownMenuPrimitive.Portal;
// Exports
export const DropdownMenuRoot = DropdownMenuPrimitive.Root;
export const DropdownMenuTrigger = StyledTrigger;
export const DropdownMenuItem = StyledItem;
export const DropdownMenuCheckboxItem = StyledCheckboxItem;
export const DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup;
export const DropdownMenuRadioItem = StyledRadioItem;
export const DropdownMenuItemIndicator = StyledItemIndicator;
export const DropdownMenuLabel = StyledLabel;
export const DropdownMenuSeparator = StyledSeparator;
export const DropdownMenuArrow = StyledArrow;
export const DropdownMenuContent = (_a) => {
    var { children, forceMount } = _a, props = __rest(_a, ["children", "forceMount"]);
    return (_jsx(StyledPortal, { forceMount: forceMount, children: _jsxs(StyledContent, Object.assign({}, props, { children: [_jsx("div", { className: "overflow-hidden rounded-md", children: children }), _jsx(StyledArrow, {})] })) }));
};
export const DropdownMenuItemRightSlot = withClassName('div', 'ml-auto pl-md');
export const DropdownMenu = Object.assign(DropdownMenuRoot, {
    Content: DropdownMenuContent,
    Trigger: StyledTrigger,
    Item: StyledItem,
    CheckboxItem: StyledCheckboxItem,
    RadioGroup: DropdownMenuPrimitive.RadioGroup,
    RadioItem: StyledRadioItem,
    ItemIndicator: StyledItemIndicator,
    Label: StyledLabel,
    Separator: StyledSeparator,
    Arrow: StyledArrow,
    ItemRightSlot: DropdownMenuItemRightSlot,
});
//# sourceMappingURL=DropdownMenu.js.map